export function resolveHookState(newState, currentState) {
    if (typeof newState === 'function') {
        return newState(currentState);
    }
    return newState;
}



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/react-use/esm/util/resolveHookState.js
// module id = wV8j
// module chunks = 0